import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  ApiVisa,
  BranchLocationLinkService,
  BranchService,
  LocationContainerModel,
  LocationService,
  Pagination,
} from 'blg-akaun-ts-lib';
import { ReplaySubject, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { DropDownService } from '../../services/drop-down-service';

@Component({
  selector: 'blg-select-location-drop-down-v2',
  templateUrl: './select-location-drop-down-v2.component.html',
  styleUrls: ['./select-location-drop-down-v2.component.css'],
})
export class SelectLocationDropDownV2Component implements OnInit {
  @Input() location = new FormControl(null, Validators.required);
  @Input() apiVisa: ApiVisa;
  @Input() required: boolean;
  @Input() branchSelectedGuid: string;
  @Input() label = "Location";
  @Input() controlName: string;

  @Output() locationChange = new EventEmitter<FormControl>();
  @Output() locationSelected = new EventEmitter<LocationContainerModel>();

  serverSideFiltering = new FormControl();
  serverSideSearching = false;
  filteredOptions$: ReplaySubject<LocationContainerModel[]> = new ReplaySubject<
    LocationContainerModel[]
  >(1);
  locationList: LocationContainerModel[] = [];
  selectedLocation = new LocationContainerModel();
  locations: any = [];

  protected _onDestroy = new Subject<void>();
  unlinkedLocation: boolean;

  constructor(
    private lctnService: LocationService,
    private branchLocationLinkService: BranchLocationLinkService,
    private branchService: BranchService,
    private dropDownService: DropDownService
  ) {}

  ngOnInit() {
    // listen for search field value changes
    this.serverSideFiltering.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.LocationFiltering();
      });

    // load the initial location list
    this.getAllLocations();
    this.location.markAsTouched();
  }

  ngOnChanges() {
    if (this.branchSelectedGuid) {
      this.getAllLocations();
      
      // Set default location when the branch changes
      this.setDefaultLocation();
    }
  }

  async setDefaultLocation() {
    if (!this.location.value) return; // Do not set default location if the location is already provided

    if (this.branchSelectedGuid) {
      let defaultLocationGuid;
      // Fetch the default location based on the branch
      await this.branchService.getByGuid(this.branchSelectedGuid, this.apiVisa)
        .subscribe((branch) => {
          // Logic to determine the defaultLocationGuid
          if (branch.data.bl_fi_mst_branch?.location_guid) {
            defaultLocationGuid = branch.data.bl_fi_mst_branch.location_guid;
          } else if (
            branch.data.bl_fi_mst_branch_ext.find(
              (x) => x.param_code === "MAIN_LOCATION"
            )
          ) {
            defaultLocationGuid = branch.data.bl_fi_mst_branch_ext.find(
              (x) => x.param_code === "MAIN_LOCATION"
            )?.value_string;
          }
          
          // Set the defaultLocation in the form control
          if (defaultLocationGuid) {
            this.location.setValue(defaultLocationGuid);
          }
        });
    }
  }

  async getAllLocations() {
    //empty the prev list when selected branch changed
    this.locationList = [];
    this.locations = [];
    this.filteredOptions$.next(null);

    console.log("this.branchSelectedGuid", this.branchSelectedGuid);
    //if there is a selected branch
    if (this.branchSelectedGuid) {
      let defaultLocationGuid;

      await this.branchService
        .getByGuid(this.branchSelectedGuid, this.apiVisa)
        .subscribe((branch) => {
          if (branch.data.bl_fi_mst_branch?.location_guid) {
            defaultLocationGuid = branch.data.bl_fi_mst_branch.location_guid;
          } else if (
            branch.data.bl_fi_mst_branch_ext.find(
              (x) => x.param_code === "MAIN_LOCATION"
            )
          ) {
            defaultLocationGuid = branch.data.bl_fi_mst_branch_ext.find(
              (x) => x.param_code === "MAIN_LOCATION"
            )?.value_string;
          }

          let locationGuidsList = [];
          let pagination = new Pagination();
          pagination.limit = 1000;
          pagination.conditionalCriteria = [];
          pagination.conditionalCriteria.push({
            columnName: "guid_branch",
            operator: "=",
            value: this.branchSelectedGuid,
          });

          this.branchLocationLinkService
            .getByCriteria(pagination, this.apiVisa)
            .subscribe((response) => {
              if (response.data && response.data.length) {
                for (let i = 0; i < response.data.length; i++) {
                  if (
                    response.data[i].bl_fi_mst_branch_location_link
                      .guid_location !== null
                  ) {
                    locationGuidsList.push(
                      response.data[
                        i
                      ].bl_fi_mst_branch_location_link.guid_location.toString()
                    );
                  }
                }

                console.log("Default Location", defaultLocationGuid);
                let formData = {
                  limit: null,
                  orderBy: "code",
                  order: "ASC",
                };

                this.dropDownService
                  .get("location", formData, this.apiVisa)
                  .pipe(
                    map((lctns) => {
                      //empty the prev list when selected branch changed
                      this.locationList = [];
                      this.locations = [];
                      this.filteredOptions$.next(null);
                      if (locationGuidsList?.length > 0) {
                        this.locationList = lctns.data.filter((record) =>
                          locationGuidsList.includes(record.guid)
                        );
                        this.locations = lctns.data.filter((record) =>
                          locationGuidsList.includes(record.guid)
                        );
                      } else {
                        this.locationList = lctns.data;
                        this.locations = lctns.data;
                      }

                      const allValuesDifferent = this.locations.every(
                        (item) => item.guid !== this.location.value
                      );
                      this.unlinkedLocation = !allValuesDifferent;

                      if (
                        this.location.value === null ||
                        this.location.value === undefined ||
                        lctns.data.some(
                          (x) => x.guid === this.location.value
                        ) ||
                        defaultLocationGuid
                      ) {
                        if (
                          lctns.data.some((x) => x.guid === this.location.value)
                        ) {
                          this.location.setValue(this.location.value);
                        } else if (
                          lctns.data.some((x) => x.guid === defaultLocationGuid)
                        ) {
                          this.location.setValue(defaultLocationGuid);
                        } else if (lctns.data.length === 1) {
                          this.location.setValue(lctns.data[0].guid);
                        }
                      }

                      // sorting
                      const sorted = this.locations.sort((a, b) =>
                        a.code < b.code ? -1 : 1
                      );
                      //fill the drop down
                      this.filteredOptions$.next(this.locations.slice());
                    })
                  )
                  .subscribe();
              }
            });
        });
    }
  }

  LocationFiltering() {
    if (!this.locations) {
      return;
    }
    // get the search keyword
    let search = this.serverSideFiltering.value;
    if (!search) {
      this.filteredOptions$.next(this.locations.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the locations
    this.filteredOptions$.next(
      this.locations.filter(
        (option) =>
          (option.code
            ? option.code.toLowerCase().indexOf(search) > -1
            : null) ||
          (option.name ? option.name.toLowerCase().indexOf(search) > -1 : null)
      )
    );
  }

  onSelect(locationGuid: string) {
    if (locationGuid) {
      this.location.patchValue(locationGuid);
      this.lctnService
        .getByGuid(locationGuid, this.apiVisa)
        .subscribe((response) => {
          this.selectedLocation = response.data;
          this.locationSelected.emit(this.selectedLocation);
        });
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
